import type { IMixpanelClient, IHotjarClient } from '@Shared';


let hostRouter: any | null = null;
let basePath: string | null = null;
let mixpanelClient: IMixpanelClient | null = null;
let hotjarClient: IHotjarClient | null = null;

export const init = ({ router, basePath: base, mixpanelClient: mixpanel, hotjarClient: hotjar }: {
    router: any;
    basePath: string;
    mixpanelClient: IMixpanelClient;
    hotjarClient: IHotjarClient;
}) => {
    console.log('[Esignature MFE] Config initialized');
    hostRouter = router;
    basePath = base;
    mixpanelClient = mixpanel || null; 
    hotjarClient = hotjar || null;
};

export const getHostRouter = () => hostRouter;
export const getBasePath = () => basePath;
export const getMixpanelClient = (): IMixpanelClient | null => mixpanelClient;
export const getHotjarClient = (): IHotjarClient | null => hotjarClient;

export default {
    init,
    getHostRouter,
    getBasePath,
    getMixpanelClient,
    getHotjarClient
};
